module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-right.74d9614d.svg";